import { useContext } from 'react';
import { Menu } from '@shared/components/Menu';
import { CardChannelContext } from '@shared/components/blocks/contexts/channel';
import { i18n } from '@shared/util/i18n';
import { useNavigator } from '@shared/util/navigation';
import { ChannelPermissionsContext } from '@shared/util/permissions/ChannelPermissionsContext';

interface Props {
  entityId: string;
}

export function DuplicateMenuItem({ entityId }: Props) {
  const { canCreateCard } = useContext(ChannelPermissionsContext);
  const channel = useContext(CardChannelContext);
  const { navigate } = useNavigator();

  if (!canCreateCard.enabled) {
    return null;
  }

  const onClick = () => {
    navigate('CardCreate', {
      channelSlug: channel?.slug ?? '',
      fromEntity: entityId,
    });
  };

  return <Menu.Item label={i18n('card.menu.actions.duplicateFrom')} onClick={onClick} />;
}
